import React, { useState } from 'react';
import '../styles/GridLayoutSelector.css';

const GridLayoutSelector = ({ onSelect, timeLeft }) => {
  const [selectedGrid, setSelectedGrid] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const getLayouts = (count) => {
    switch (count) {
      case 1:
        return [];
      case 2:
        return [
          { id: 1, name: 'Vertikal Tengah', className: 'layout-vertical-center' },
          { id: 2, name: 'Vertikal Atas', className: 'layout-vertical-top' },
          { id: 3, name: 'Ujung Atas & Bawah (Gap)', className: 'layout-vertical-gap' }
        ];
      case 3:
        return [
          { id: 1, name: 'Vertikal Tengah', className: 'layout-vertical-center-3' },
          { id: 2, name: 'Ujung Atas, Tengah, Bawah', className: 'layout-vertical-ends' }
        ];
      case 4:
        return [
          { id: 1, name: 'Vertikal Tengah', className: 'layout-vertical-center-4' },
          { id: 2, name: '2 Atas & 2 Bawah', className: 'layout-2-top-2-bottom' },
          { id: 3, name: 'Besar-Kecil-Besar-Kecil Tengah', className: 'layout-mix-center' }
        ];
      default:
        return [];
    }
  };

  const handleGridSelect = (grid) => {
    setSelectedGrid(grid);
    setSelectedLayout(null); // Reset layout selection when grid changes
  };

  const handleLayoutSelect = (layout) => {
    setSelectedLayout(layout);
    onSelect({ grid: selectedGrid, layout });
  };

  return (
    <div className="grid-layout-selector">
      <h2>Pilih Jumlah Foto dan Layout</h2>
      <div className="timer">Waktu tersisa: {formatTime(timeLeft)}</div>
      
      <div className="selection-container">
        <div className="grid-selection">
          <h3>Jumlah Foto</h3>
          <div className="grid-options">
            <button 
              onClick={() => handleGridSelect(2)} 
              className={`grid-option ${selectedGrid === 2 ? 'selected' : ''}`}
            >
              <div className="grid-preview double"></div>
              <span>2 Foto</span>
            </button>
            <button 
              onClick={() => handleGridSelect(3)} 
              className={`grid-option ${selectedGrid === 3 ? 'selected' : ''}`}
            >
              <div className="grid-preview triple"></div>
              <span>3 Foto</span>
            </button>
            <button 
              onClick={() => handleGridSelect(4)} 
              className={`grid-option ${selectedGrid === 4 ? 'selected' : ''}`}
            >
              <div className="grid-preview quad"></div>
              <span>4 Foto</span>
            </button>
          </div>
        </div>

        {selectedGrid && (
          <div className="layout-selection">
            <h3>Layout Foto</h3>
            <div className="layout-options">
              {getLayouts(selectedGrid).map((layout) => (
                <button
                  key={layout.id}
                  onClick={() => handleLayoutSelect(layout.id)}
                  className={`layout-option ${selectedLayout === layout.id ? 'selected' : ''}`}
                >
                  <div className={`layout-preview ${layout.className}`}></div>
                  <span>{layout.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GridLayoutSelector; 